import type { ExecutePayload, ExecutePayloadInput } from '../models/execute.types'

function normalizeNumericId(value: unknown): number | null {
  if (value === undefined || value === null || value === '') return null
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : null
}

/** Ports the workbench's coercion rules without coupling the API class to form state. */
export function cleanExecutePayload(payload: ExecutePayloadInput = {}): ExecutePayload {
  const configId = normalizeNumericId(payload.config_id)
  const configEnum = typeof payload.config_enum === 'string' ? payload.config_enum.trim() : ''
  const scheduleId = normalizeNumericId(payload.schedule_id)

  return {
    ...(configId !== null
      ? { config_id: configId }
      : configEnum
        ? { config_enum: configEnum }
        : {}),
    ...(scheduleId !== null ? { schedule_id: scheduleId } : {}),
    force: Boolean(payload.force),
    dry_run: payload.dry_run !== false,
    notify: Boolean(payload.notify),
  }
}
